<template>
  <footer class="site-footer">
    &copy; {{ currentYear }} NightKill. All rights reserved.
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  data() {
    return {
      currentYear: new Date().getFullYear(),
    };
  },
};
</script>

<style scoped>
.site-footer {
  text-align: center;
  padding: 1rem;
  background: #111;
  color: #aaa;
  font-size: 1rem;
  height: 1.5vh;
  min-height: 1.5vh;
  max-height: 1.5vh;
  flex-shrink: 0;
}
</style>
